export default __webpack_public_path__ + "static/superbetter-3-2ab7f9f4b613206437a2c666705419bb.webp";